import {Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2} from '@angular/core';

import {Destroyable} from '../../../destroyable.component';
import {isMobileDevice} from '../../utils/browser';
import {Preview} from '../../utils/files';

@Component({
  selector: 'gp-view-document-side-panel',
  templateUrl: './view-document-side-panel.component.html',
  styleUrls: ['./view-document-side-panel.component.scss']
})
export class ViewDocumentSidePanelComponent extends Destroyable implements OnInit, OnDestroy {
  @Input() public preview: Preview;
  @Input() public deletable: boolean;
  @Input() public error = false;
  @Input() public noSupportedFormat = false;
  @Input() public documentsLimitReached = false;
  @Input() public currentFileName = '';
  @Input() public loading = false;
  /* css class that does not trigger the call of closeSidePanel*/
  @Input() public cssClass = 'document-row';
  @Input() public confirmModalOpened = false;
  @Output() public close = new EventEmitter<boolean>();
  @Output() public delete = new EventEmitter<boolean>();

  public removeClickOutsideListener;

  constructor(private element: ElementRef,
              private renderer: Renderer2) {
    super();
  }

  public ngOnInit() {
    this.addClickOutsideListener();
  }

  public ngOnDestroy() {
    this.removeClickOutsideListener();
    super.ngOnDestroy();
  }

  public closeSidePanel() {
    this.close.emit(true);
  }

  public deleteDocument() {
    this.confirmModalOpened = true;
    this.delete.emit(true);
  }

  private addClickOutsideListener() {
    this.removeClickOutsideListener = this.renderer.listen('window', 'click', (event: Event) => {
      const targetElement = <HTMLElement>event.target;
      const nativeElement = <HTMLElement>this.element.nativeElement;
      this.closeSidePanelOnFocusLost(targetElement, nativeElement);
    });
  }

  private closeSidePanelOnFocusLost(targetElement: HTMLElement, nativeElement: HTMLElement) {
    if (!isMobileDevice()) {
      const isTableRow = targetElement.closest('tr')?.classList?.contains(this.cssClass);
      const isSidePanel = nativeElement.contains(targetElement);
      if (!isSidePanel && !isTableRow && !this.confirmModalOpened) {
        this.closeSidePanel();
      }
    }
  }

}
